import React from 'react';
import { useGlobal } from 'reactn';
import Card from '../../common/card/Card';
import Button from '../../common/button/Button';
import EmergencyIcon from '../../assets/emergency-icon.png';
import ContactIcon from '../../assets/contact-icon.png';
import EmailIcon from '../../assets/email-icon.png';

const ContactUs = ({ ...rest }) => {
  const [siteDetails] = useGlobal('siteDetails');
  if (!siteDetails) {
    return null;
  }
  const {
    mcwa_contact_phone,
    mcwa_contact_emergency_phone,
    mcwa_support_email,
    mcwa_support_hours,
  } = siteDetails;

  return (
    <Card
      title="Contact Us"
      backgroundClass="bg-blue-dark"
      bodyClassName="justify-between"
      {...rest}
    >
      <div>
        <div className="flex items-center mb-4">
          <img className="mr-4" src={ContactIcon} alt="Icon with phone" />
          <span className="text-white text-2xl">{mcwa_contact_phone}</span>
        </div>
        <div className="text-white mb-4">
          <span className="font-medium">Hours: </span>
          <span className="font-thin">{mcwa_support_hours}</span>
        </div>
        <div className="text-white mb-4">
          <span className="font-medium">Email Us: </span>
          <span className="font-thin">information@mcwa.com</span>
        </div>
      </div>
      <div>
        <Button
          iconUrl={EmailIcon}
          href={`mailto:${mcwa_support_email}`}
          target="_top"
          className="mb-8 w-full"
        >
          Send Us An Email
        </Button>
        <div className="h-px bg-blue mb-4" />
        <div className="text-white mb-4">After-Hours Emergencies:</div>
        <div className="flex items-center">
          <img
            className="mr-4"
            src={EmergencyIcon}
            alt="Icon with ringing bell"
          />
          <span className="text-white text-2xl">
            {mcwa_contact_emergency_phone}
          </span>
        </div>
      </div>
    </Card>
  );
};

export default ContactUs;
